{
  "version": 1,
  "asset_id": "65f4cd4c-5c91-4dca-8aaa-28990a8d7526",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/65f4cd4c-5c91-4dca-8aaa-28990a8d7526/prima2.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/65f4cd4c-5c91-4dca-8aaa-28990a8d7526/prima2.webp",
  "original_filename": "prima2.webp",
  "size": 66480,
  "content_type": "image/webp",
  "created_at": "2026-08-07T09:36:29Z"
}
